import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, inject, OnDestroy, OnInit } from '@angular/core';
import { CdsAccordionModule } from '@cds/ng-web-components/accordion';
import { CdsStepperModule } from '@cds/ng-web-components/stepper';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { StepperComponent } from './layout/stepper/stepper.component';
import { filter } from 'rxjs/operators';
import { ReturnToClaimComponent } from './shared/components/return-to-claim/return-to-claim.component';
import { SessionTimeoutService } from './core/services/session-timeout.service';
import { SessionStorageService } from './core/services/session-storage.service';
import { Subscription } from 'rxjs';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { NewRelicService } from './shared/services/newrelic.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, CdsAccordionModule, CdsStepperModule, HeaderComponent, FooterComponent, StepperComponent, ReturnToClaimComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription?: Subscription;
  private sessionTimeout = inject(SessionTimeoutService);
  private sessionStorage = inject(SessionStorageService);
  private newRelicService: NewRelicService = inject(NewRelicService);

  title = 'eclaim-reengineering-ui';
  showStepper = false;
  // ✅ Routes where stepper should be hidden
  private routesWithoutStepper = [
    '/eclaim', '/claim-completion', '/maintenance', '/system-maintenance', '/browser-compatibility', '/recommended-browser'
  ];
  constructor(private router: Router
  ) {
  }

  ngOnInit(): void {
    // ✅ Listen to route changes and update stepper visibility

    //TO-BE-REMOVED Ideally the script should be loaded on App Initializer and no timeout should be used so that it can be be synced with page load
    //Should be planned with some other major release
    setTimeout(() => {
      this.newRelicService.setGlobalAttributes({ userAgentString: navigator?.userAgent })
    }, 5000);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showStepper = !this.routesWithoutStepper.some(route =>
          event.urlAfterRedirects.includes(route)
        );
      });

    // ✅ Check initial route
    const currentUrl = this.router.url;
    this.showStepper = this.routesWithoutStepper.some(route =>
      currentUrl.includes(route)
    );

    // ✅ Start session timeout if user is logged in
    this.checkAndStartSession();

    // ✅ Monitor route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkAndStartSession();
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.sessionTimeout.stop();
  }

  private checkAndStartSession(): void {
    const sessionId = this.sessionStorage.getSessionId();

    if (sessionId && !this.sessionTimeout.isActive()) {
      // ✅ Validate session first
      if (this.sessionTimeout.isSessionValid()) {
        this.sessionTimeout.start();
      } else {
        // Session expired, clear and redirect
        this.sessionStorage.clearAppData();
        this.router.navigate(['/eclaim']);
      }
    } else if (!sessionId && this.sessionTimeout.isActive()) {
      // User logged out
      this.sessionTimeout.stop();
    }
  }
}
